export default __webpack_public_path__ + "static/design-f50600802dd17e694ad01cc052719ca8.mp4";